// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "44e870d84138694ad22f2c7c6a04fdff" + ".js";
};